import Layout from "../../components/structure/layout";
import { motion } from "framer-motion";

const PrivacyPolicy = ({ siteConfig, storyBlok, language }) => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: "tween", ease: "easeInOut", duration: 0.6 },
    },
  };

  return (
    <Layout siteConfig={siteConfig} storyBlok={storyBlok} forceDarkNav>
      <motion.div
        variants={fadeIn}
        initial="hidden"
        animate="show"
        className="bg-white min-h-screen"
      >
        <div className="mx-auto max-w-4xl px-6 py-16 lg:px-8 lg:py-24">
          <h1 className="font-lexend text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-10">
            Privacy Policy
          </h1>

          <div className="font-lexend text-sm leading-7 text-gray-700 space-y-8">
            <p>
              Questa Privacy Policy è resa ai sensi dell'art. 13 del Regolamento
              Europeo n. 679/2016 e si applica esclusivamente a tutti i Dati
              raccolti attraverso il Sito web hydrotradesrl.it. La presente
              Privacy Policy è soggetta ad aggiornamenti che verranno pubblicati
              puntualmente sul Sito web. La presente Privacy Policy, unitamente
              alla Cookie Policy, stabilisce le basi sulle quali verranno
              elaborati i Dati personali dell'Utente.
            </p>

            <Section title="Titolare del Trattamento">
              <p>
                Il Titolare del Trattamento dei Dati raccolti da questo Sito web
                è hydrotradesrl.it, con sede in Via Cagliari snc, 20060 Trezzano
                Rosa, P.IVA 11735470962 email:{" "}
                <a
                  href="mailto:admin@hydrotradesrl.it"
                  className="text-blue underline hover:opacity-80"
                >
                  admin@hydrotradesrl.it
                </a>
              </p>
            </Section>

            <Section title="Modalità di Trattamento dei Dati Personali">
              <p>
                I Dati Personali forniti o acquisiti saranno oggetto di
                Trattamento improntato ai principi di correttezza, liceità,
                trasparenza e di tutela della riservatezza ai sensi delle vigenti
                normative. Il Titolare tratta i Dati Personali degli Utenti
                adottando le opportune misure di sicurezza volte ad impedire
                l'accesso, la divulgazione, la modifica o la distruzione non
                autorizzate dei Dati Personali. Il Trattamento viene effettuato
                mediante strumenti informatici e/o telematici, con modalità
                organizzative e con logiche strettamente correlate alle finalità
                indicate.
              </p>
            </Section>

            <Section title="Finalità del Trattamento dei Dati personali e Base giuridica">
              <p>
                I Dati Personali possono essere raccolti in modo autonomo dal
                Titolare o tramite terze parti. In questo caso i sistemi
                informatici e le procedure software preposte al funzionamento del
                presente Sito web acquisiscono alcuni Dati Personali degli
                Utenti, di carattere tecnico-informatico (ad es. l'indirizzo IP,
                il tipo di browser utilizzato, il sistema operativo, il nome di
                dominio e gli indirizzi di siti web dai quali è stato effettuato
                l'accesso o l'uscita, ecc.), la trasmissione dei quali è
                connaturata al normale funzionamento di internet. Tali Dati
                potranno essere trattati al solo fine di ricavare informazioni
                statistiche anonime sull'uso del sito e/o per controllarne il
                corretto funzionamento e saranno cancellati immediatamente dopo
                l'elaborazione.
              </p>
              <p className="mt-4">
                I Dati che l'Utente sceglie di fornire spontaneamente sono
                raccolti per consentire al Sito web di fornire i propri servizi,
                così come per le seguenti Finalità:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-3">
                <li>
                  <strong>a)</strong> per adempiere a qualunque tipo di obbligo
                  contemplato e previsto dalle vigenti leggi, regolamenti,
                  normative correlate ed usi commerciali, in particolare, in
                  materia tributaria/fiscale. Questo trattamento è obbligatorio
                  per adempiere un obbligo legale al quale è soggetto il Titolare
                  del Trattamento;
                </li>
                <li>
                  <strong>b)</strong> per altre finalità accessorie o collegate a
                  quelle sopra indicate e comunque rientranti nell'ambito delle
                  attività del Sito web;
                </li>
                <li>
                  <strong>c)</strong> per dar seguito alle specifiche richieste
                  rivolte al Titolare dall'Utente per comunicazioni di natura
                  informativa relative ai Servizi dello stesso Titolare, tramite
                  messaggi di posta elettronica o di altri strumenti di
                  comunicazione quali ad esempio telefono o strumenti di
                  messaggistica. Questo trattamento è facoltativo e basato sul
                  consenso dell'Utente, tuttavia la mancata comunicazione di uno
                  o più Dati comporterà l'impossibilità di dare risposta alla
                  richiesta di informazioni e di fruire dei servizi offerti dal
                  Titolare;
                </li>
                <li>
                  4 comma, Codice della Privacy, e a condizione che l'utente non
                  eserciti il diritto di opposizione; Questo trattamento è basato
                  sull'art. 130, 4 comma, del Codice della Privacy così come
                  novellato dal D.lgs n.101 del 2018;
                </li>
                <li>
                  <strong>d)</strong> per effettuare analisi statistiche su dati
                  aggregati e anonimi per analizzare i comportamenti, dell'Utente
                  per migliorare i prodotti e i servizi forniti dal Titolare
                  nonché soddisfare le aspettative dell'Utente stesso;
                </li>
                <li>
                  <strong>e)</strong> per attività di profilazione a fini
                  marketing. Questo Trattamento è basato sul consenso liberamente
                  espresso dall'Utente.
                </li>
              </ul>
            </Section>

            <Section title="Categoria di Dati Personali trattati">
              <p>
                Fra i Dati Personali trattati da questo Sito web, in modo
                autonomo o tramite terze parti, ci sono: Cookie, Dati di
                utilizzo, Email e Nome. I Dati Personali possono essere raccolti
                in modo autonomo dal Titolare o tramite terze parti. I Dati
                Personali possono essere forniti volontariamente dall'Utente
                quando utilizza il Sito web, comunicando con il Titolare via
                mail, via telefono o messaggistica chat. L'invio facoltativo,
                esplicito e volontario di posta elettronica tramite gli indirizzi
                indicati su questo Sito web, comporta la successiva acquisizione
                dell'indirizzo del mittente, necessario per rispondere alle
                richieste, nonché degli eventuali altri Dati Personali inseriti
                nella email. Il consenso al conferimento dei Dati da parte
                dell'Utente è necessario per essere inserito nei database del
                Titolare ed ai fini dell'instaurazione e del corretto svolgimento
                di quanto offerto dallo stesso ai suoi Utenti, nonché ai terzi
                per l'adempimento della singola attività richiesta. Il mancato
                conferimento impedisce, pertanto, la registrazione nei database
                del Titolare, il perfezionamento di eventuali contratti, nonché
                l'esecuzione degli stessi e di ogni altra eventuale attività.
              </p>
            </Section>

            <Section title="Comunicazione dei Dati">
              <p>
                Oltre al Titolare, in alcuni casi, potrebbero avere accesso ai
                Dati:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-3">
                <li>
                  <strong>a)</strong> categorie di Incaricati a ciò appositamente
                  formati coinvolti nell'organizzazione del Sito web (personale
                  amministrativo, commerciale, marketing, legali, amministratori
                  di sistema);
                </li>
                <li>
                  <strong>b)</strong> soggetti esterni (come fornitori di servizi
                  tecnici terzi, hosting provider, società informatiche, agenzie
                  di comunicazione) nominati anche Responsabili del Trattamento
                  da parte del Titolare ex art. 28 GDPR. L'elenco aggiornato dei
                  Responsabili, se nominati, potrà sempre essere richiesto al
                  Titolare del Trattamento;
                </li>
                <li>
                  <strong>c)</strong> soggetti pubblici o privati che possono
                  accedere ai Dati in osservanza di obblighi di legge;
                </li>
                <li>
                  <strong>d)</strong> soggetti che svolgono compiti accessori e
                  strumentali rispetto all'attività del Titolare;
                </li>
              </ul>
            </Section>

            <Section title="Tempi del Trattamento">
              <p>
                Così come espressamente previsto dall'art. 5, co. 1, lett. e) del
                GDPR, i Dati sono conservati per il tempo necessario al
                Trattamento degli stessi in relazione allo svolgimento del
                servizio richiesto dall'Utente, o richiesto dalle Finalità
                descritte in questo documento e in particolare:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-3">
                <li>
                  I Dati raccolti per obblighi contrattuali saranno conservati
                  per il tempo necessario all'espletamento delle finalità
                  suddette e secondo quanto previsto dalla legge;
                </li>
                <li>
                  I Dati raccolti per obblighi fiscali/amministrativi o per
                  obblighi contrattuali saranno conservati per il tempo
                  necessario all'espletamento delle finalità suddette e secondo
                  quanto previsto dalla legge;
                </li>
                <li>
                  I Dati raccolti per Finalità riconducibili al legittimo
                  interesse del Titolare saranno trattenuti sino al
                  soddisfacimento di tale interesse. L'Utente può ottenere
                  ulteriori informazioni in merito all'interesse legittimo
                  perseguito dal Titolare contattando il Titolare.
                </li>
                <li>
                  I Dati raccolti in base al Consenso dell'Utente potranno essere
                  conservati fino a che tale Consenso non venga revocato;
                </li>
              </ul>
              <p className="mt-4">
                I Dati possono essere conservati dal Titolare per un periodo più
                lungo in ottemperanza a obblighi di legge o per ordine di
                un'autorità. Al termine del periodo di conservazione i Dati
                Personali saranno cancellati e pertanto, non potranno più essere
                esercitati i diritti di accesso, cancellazione, rettificazione e
                portabilità dei Dati.
              </p>
            </Section>

            <Section title="Cookie">
              <p>
                Questo Sito web utilizza i cookie. I cookie sono piccoli file di
                testo che possono essere utilizzati dai siti web per rendere più
                efficiente l'esperienza per l'utente e per personalizzare
                contenuti e gli annunci, fornire le funzioni dei social network e
                analizzare il traffico. Cookie Policy
              </p>
            </Section>

            <Section title="Luogo del Trattamento e trasferimento dei Dati all'estero">
              <p>
                I Dati sono trattati presso la sede operativa del Titolare. Per
                ulteriori informazioni si può contattare il Titolare del
                Trattamento. I Dati potranno essere trattati da persone fisiche
                e/o soggetti giuridici operanti per conto del Titolare e in forza
                di specifici vincoli contrattuali e aventi sede in Paesi membri
                UE o extra UE. Nel caso in cui i Dati vengano trasferiti al di
                fuori del SEE, il Titolare adotterà ogni misura contrattuale
                idonea a garantire un'adeguata protezione dei Dati.
              </p>
            </Section>

            <Section title="Strumenti utilizzati per il Trattamento dei Dati Personali">
              <SubSection title="Contatto">
                <p>
                  L'Utente, contattandoci direttamente con i propri Dati,
                  acconsente al loro utilizzo per rispondere alle richieste di
                  informazioni, o di qualunque altra finalità indicata. Dati
                  Personali raccolti: Email e/o Numero di telefono, Nome e
                  Cognome.
                </p>
              </SubSection>

              <SubSection title="Altri strumenti di contatto — Chat Bot">
                <p>
                  Per gestire le richieste di informazioni con gli utenti questo
                  sito web utilizza un servizio di Chat fornito da:
                </p>
                <p className="mt-2">
                  <strong>Facebook Messenger live chat</strong> — Questo servizio
                  offerto da Facebook Ireland Ltd consente che attraverso un
                  plugin, i visitatori di questo Sito web, dopo aver effettuato
                  l'opt-in con il loro account di Facebook, possano comunicare in
                  tempo reale con il Titolare. Luogo del trattamento: Irlanda.
                </p>
              </SubSection>

              <SubSection title="Protezione SPAM">
                <p>
                  Questi servizi analizzano il traffico di questo Sito web,
                  potenzialmente contenente Dati Personali degli Utenti, al fine
                  di filtrarlo da parti di traffico, messaggi e contenuti
                  riconosciuti come SPAM.
                </p>
                <p className="mt-2">
                  <strong>Akismet (Automattic Inc.)</strong> — Akismet è un
                  servizio di protezione dallo SPAM fornito da Automattic Inc.
                  Dati personali raccolti: Varie tipologie di Dati secondo quanto
                  specificato dalla privacy policy del servizio. Luogo del
                  trattamento: USA.
                </p>
              </SubSection>

              <SubSection title="Statistica">
                <p>
                  I servizi di statistica permettono al Titolare del Trattamento
                  esclusivamente di monitorare e analizzare i dati di traffico e
                  servono a tener traccia del comportamento dell'Utente. Questo
                  Sito web utilizza i seguenti servizi:
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-3">
                  <li>
                    <strong>Google Analytics (Google Ireland Limited)</strong> —
                    Google Analytics è un servizio di analisi fornito da Google
                    Ireland Limited. Google utilizza i Dati Personali raccolti
                    allo scopo di tracciare ed esaminare l'utilizzo di questo Sito
                    web, compilare report e condividerli con gli altri servizi
                    sviluppati da Google. In questo sito è attiva la funzione di
                    anonimizzazione dell'indirizzo IP. Luogo del trattamento:
                    Irlanda.
                  </li>
                  <li>
                    <strong>
                      Monitoraggio conversioni pixel di Facebook (Facebook Ireland
                      Ltd.)
                    </strong>{" "}
                    — Il monitoraggio conversioni di Facebook (pixel di Facebook) è
                    un servizio di statistiche fornito da Facebook. Il pixel di
                    Facebook monitora le conversioni che possono essere attribuite
                    alle inserzioni di Facebook. Luogo del trattamento: Irlanda.
                  </li>
                  <li>
                    <strong>
                      Google Tag Manager (Google Ireland Limited)
                    </strong>{" "}
                    — Google Tag Manager è un servizio che permette di gestire e
                    monitorare tutti i Tag di terze parti sul Sito web. Luogo del
                    trattamento: Irlanda.
                  </li>
                </ul>
              </SubSection>

              <SubSection title="Interazione con i Social Network">
                <p>
                  Questi servizi permettono di effettuare interazioni con i social
                  network direttamente dalle pagine di questo Sito web. Le
                  interazioni e le informazioni acquisite da questo Sito web sono
                  in ogni caso soggette alle impostazioni privacy dell'Utente
                  relative ad ogni social network.
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>
                    <strong>Facebook (Facebook Ireland Ltd.)</strong> — Dati
                    Personali raccolti: Cookie e Dati di utilizzo. Luogo del
                    trattamento: Irlanda.
                  </li>
                  <li>
                    <strong>
                      LinkedIn (LinkedIn Ireland Unlimited Company)
                    </strong>{" "}
                    — Dati Personali raccolti: Cookie e Dati di utilizzo. Luogo del
                    trattamento: Irlanda.
                  </li>
                </ul>
              </SubSection>

              <SubSection title="Remarketing e Retargeting">
                <p>
                  Questi servizi consentono a questo Sito web di comunicare,
                  ottimizzare e servire annunci pubblicitari basati sull'utilizzo
                  passato di questo Sito web da parte dell'Utente. Questo Sito web
                  utilizza i seguenti servizi:
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-3">
                  <li>
                    <strong>Facebook Remarketing (Facebook Ireland Ltd)</strong> —
                    Facebook Remarketing è un servizio di Remarketing e Behavioral
                    Targeting fornito da Facebook, che collega l'attività di questo
                    Sito web con il network di advertising Facebook. Le
                    informazioni rilevate sono anonime agli operatori di questo
                    Sito e non possono essere utilizzate per individuare l'identità
                    di un singolo utente.
                  </li>
                  <li>
                    <strong>Google ADS</strong> — Google ADS è un servizio fornito
                    da Google Ireland Limited che collega questo Sito web con il
                    network di advertising di Google. Questo Sito web fa uso delle
                    funzionalità Remarketing di Google Analytics combinate con la
                    possibilità di adattamento a diversi dispositivi di Google ADS.
                    Dati Personali raccolti: Cookie e Dati di utilizzo. Luogo del
                    trattamento: Irlanda.
                  </li>
                </ul>
              </SubSection>

              <SubSection title="Contenuti su piattaforme esterne">
                <p>
                  Questi servizi permettono di visualizzare contenuti ospitati su
                  piattaforme esterne direttamente dalle pagine di questo Sito web
                  e di interagire con essi.
                </p>
                <p className="mt-2">
                  <strong>Google Fonts</strong> — Google Fonts è un servizio di
                  visualizzazione di stili di carattere fornito da Google Ireland
                  Limited che permette a questo Sito Web di integrare tali
                  contenuti all'interno delle proprie pagine. Dati Personali
                  raccolti: Dati di utilizzo. Luogo del trattamento: Irlanda.
                </p>
              </SubSection>
            </Section>

            <Section title="Esercizio dei diritti dell'interessato">
              <p>
                L'Interessato ha diritto di esercitare le facoltà previste agli
                art. 7, 15-22 del Reg. Europeo 679/2016. In particolare, ha
                diritto di revocare il proprio consenso in qualsiasi momento e,
                dietro semplice richiesta al Titolare del Trattamento, potrà
                chiedere l'accesso ai Dati Personali, ricevere i Dati personali
                forniti al Titolare e ove possibile trasmetterli ad un altro
                Titolare del trattamento senza impedimenti (c.d. portabilità),
                ottenere l'aggiornamento, la limitazione del trattamento, la
                rettificazione dei Dati e la cancellazione di quelli trattati in
                difformità dalla normativa vigente. Ha diritto, per motivi
                legittimi, di opporsi al Trattamento dei Dati Personali che lo
                riguardano ed al Trattamento per fini di invio di materiale
                pubblicitario, di vendita diretta e per il compimento di ricerche
                di mercato. Ha altresì diritto a proporre reclamo al Garante
                della Privacy quale autorità di controllo in materia di protezione
                dei dati personali. L'interessato potrà esercitare i suoi diritti
                contattando il Titolare a mezzo mail all'indirizzo:{" "}
                <a
                  href="mailto:admin@hydrotradesrl.it"
                  className="text-blue underline hover:opacity-80"
                >
                  admin@hydrotradesrl.it
                </a>
              </p>
            </Section>

            <Section title="Modifiche a questa Privacy Policy">
              <p>
                Il Titolare del Trattamento si riserva il diritto di apportare
                modifiche alla presente Privacy Policy in qualunque momento
                dandone pubblicità agli Utenti su questa pagina. Si prega dunque
                di consultare spesso questa pagina, prendendo come riferimento la
                data di ultima modifica indicata in fondo. Nel caso di mancata
                accettazione delle modifiche apportate alla presente Privacy
                Policy, l'Utente è tenuto a cessare l'utilizzo di questo Sito web
                e può richiedere al Titolare del Trattamento di rimuovere i
                propri Dati Personali. Salvo quanto diversamente specificato, la
                precedente Privacy Policy continuerà ad applicarsi ai Dati
                Personali sino a quel momento raccolti. Il Titolare non è
                responsabile per l'aggiornamento di tutti i link visualizzabili
                nella presente Privacy Policy; pertanto, ogni qualvolta un link
                non sia funzionante e/o aggiornato, gli Utenti riconoscono ed
                accettano che dovranno sempre far riferimento al documento e/o
                sezione dei siti internet richiamati da tale link.
              </p>
            </Section>
          </div>
        </div>
      </motion.div>
    </Layout>
  );
};

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-lexend text-lg font-semibold text-gray-900 mb-3">
      {title}
    </h2>
    {children}
  </div>
);

const SubSection = ({ title, children }) => (
  <div className="mt-5">
    <h3 className="font-lexend text-base font-medium text-gray-800 mb-2">
      {title}
    </h3>
    {children}
  </div>
);

export default PrivacyPolicy;
